import React from "react";
import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";

// ============================================================
// FYUNOR — Theme Toggle
// Uses next-themes (mounted in App). Renders a single icon
// button that swaps sun/moon with a fade.
// ============================================================

export default function ThemeToggle({ className }) {
  const [isDark, setIsDark] = React.useState(false);

  React.useEffect(() => {
    const root = document.documentElement;
    const update = () => setIsDark(root.classList.contains("dark"));
    update();
    const observer = new MutationObserver(update);
    observer.observe(root, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  const toggle = () => {
    const root = document.documentElement;
    root.classList.toggle("dark");
    try {
      localStorage.setItem("fyunor-theme", root.classList.contains("dark") ? "dark" : "light");
    } catch {
      /* ignore */
    }
  };

  return (
    <button
      type="button"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      onClick={toggle}
      className={cn(
        "inline-flex size-10 items-center justify-center rounded-xl text-foreground transition-colors hover:bg-surface-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        className
      )}
    >
      {isDark ? <Sun className="size-[18px]" aria-hidden="true" /> : <Moon className="size-[18px]" aria-hidden="true" />}
    </button>
  );
}